<!-- Displays all user selected tabs used for navigation through the department's documents.-->

<template>
  <mdb-row>
    <mdb-col md="3" class="my-2">
      <mdb-btn-group vertical class="btn-block">
        <mdb-btn
          class="text-left btn-block"
          color="primary"
          v-for="tab in tabs"
          :key="tab.id"
          action
          :class="{ active: tab === selectedTab}"
          @click.native="updateTabSelection(tab)"
        >
          <strong>{{tab.title}}</strong>
        </mdb-btn>
      </mdb-btn-group>
    </mdb-col>
    <mdb-col md="9">
      <DepartmentDocumentTabView v-if="!loading" :documents="formatDocumentsJson"></DepartmentDocumentTabView>
    </mdb-col>
  </mdb-row>
</template>

<script>
import { mdbRow, mdbCol, mdbBtn, mdbBtnGroup } from "mdbvue";
import axios from "axios";
import api from "@/api";
import DepartmentDocumentTabView from "@/views/departments/documents/DocumentTabView.vue";

export default {
  name: "DepartmentDocumentTab",
  components: {
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbBtnGroup,
    DepartmentDocumentTabView,
  },
  props: {
    slug: {
      type: [String],
    },
    type: {
      type: [String],
      default: "departments.DepartmentTabPage",
    },
    descendant_of: {
      type: [Number, Boolean],
    },
    fields: {
      //TODO RM? Or alter? I know the documents field is necessary, but I dont think parent_id, or tags are in use.
      type: [String],
      default: "title,tags,parent_id,documents",
    },
  },
  data() {
    return {
      loading: true,
      tabs: false,
      selectedTab: false,
      documents: false,
    };
  },
  computed: {
    axiosParams() {
      const params = new URLSearchParams();
      params.append("descendant_of", this.descendant_of);
      params.append("type", this.type);
      params.append("fields", "*");

      return params;
    },
    formatDocumentsJson() {
      return {
        name: "djflksdf",
        documents: this.selectedTab.documents,
      };
    },
  },
  methods: {
    getData() {
      this.loading = true;
      axios;
      api
        .get("pages/", {
          params: this.axiosParams,
        })
        .then((response) => {
          this.tabs = response.data.items;
          if (!this.selectedTab) {
            this.selectedTab = this.tabs[0];
          }
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => (this.loading = false));
    },
    updateTabSelection(tab) {
      this.selectedTab = tab;
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    descendant_of: function () {
      // watch it
      this.getData();
    },
  },
};
</script>
